<template>
  <div>
    <v-dialog
        v-model="dialog"
        width="75%"
        scrollable
    >
      <v-card>
        <v-card-title class="text-center">
          Escolha os displays que devem receber este slide
        </v-card-title>
        <v-card-text>
          <Player
              :value=value
              @input="update"
              :editable="false"
              :show-select="true"
              :timeline-id="timelineId"
          ></Player>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="secondary"
              @click="dialog = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-btn
        color="blue"
        @click="dialog = true"
    >
      Enviar para os displays
    </v-btn>
    <span class="blue--text ml-2" style="cursor: help"
          title="Enviar este slide para os digiplayers selecionados">?</span>

  </div>

</template>

<script>
import Player from "@/views/Player";

export default {
  props: {
    value: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    },
    timelineId: {
      required: true,
      default: 0
    },
  },

  name: "SelecionaPlayers",
  components: {Player},

  data() {
    return {
      dialog: false,
    }
  },

  methods: {
    update: function (v) {
      this.$emit('input', v)
    }
  },}
</script>
